import { ArrowLeft } from '@collinsonx/design-system/assets/icons';
import { Flex, NavLink } from '@collinsonx/design-system/core';
import { sendActionLog } from '@lib/logging';
import { ANALYTICS_TAGS, PAGENAMES } from 'config/datadog';
import { redirectToPreviousRoute } from 'config/navigation';
import useLocale from 'hooks/useLocale';
import useNavigation from 'hooks/useNavigation';
import usePayload from 'hooks/usePayload';
import useProduct from 'hooks/useProduct';
import { FAQLink } from 'utils/FAQLinks';

import classes from './TopBarLinks.module.css';

interface TopBarLinksProps {
  page: PAGENAMES;
  showBackButton?: boolean;
}

function TopBarLinks({ page, showBackButton }: TopBarLinksProps) {
  const { membershipType, payload, referrerUrl } = usePayload();
  const { isFastTrackEnabled, loungeName } = useProduct();
  const { navigateToLounge } = useNavigation();

  const handleClickBackToLounge = () => {
    sendActionLog(ANALYTICS_TAGS.ON_HIT_BACK_BUTTON, page);

    navigateToLounge();
  };

  const translations = useLocale();

  return (
    <Flex justify="space-between">
      {showBackButton ? (
        <NavLink
          className={classes.anchor}
          label={translations.lounge.topBarLinks.back}
          leftSection={<ArrowLeft size="1rem" stroke={1.5} />}
          onClick={redirectToPreviousRoute}
        />
      ) : (
        <NavLink
          className={classes.anchor}
          href={referrerUrl || '#'}
          label={`${
            translations.lounge.topBarLinks.backToLounge
          } ${loungeName.toUpperCase()}`}
          leftSection={<ArrowLeft size="1rem" stroke={1.5} />}
          onClick={handleClickBackToLounge}
          target="_top"
        />
      )}
      <NavLink
        className={classes.anchor}
        href={FAQLink(
          payload?.accountProvider,
          isFastTrackEnabled
            ? translations.fastTrack.faqLocaleValue
            : translations.booking.flightDetails.localeValue,
          membershipType,
          isFastTrackEnabled
        )}
        label={translations.lounge.topBarLinks.faqs}
        target="_blank"
      />
    </Flex>
  );
}

export default TopBarLinks;
